import { useEffect, useState } from "react";
import styles from "../css/OnevocaNewDialog.module.css";
import { OnevocaNewDialogRadioButton } from "../model/OnevocaNewDialogRadioButton";
import ListCheckBoxButton from "./ListCheckBoxButton";
import BigButton from "../BigButton";
import SpacingView from "./SpaingView";

interface OnevocaNewDialogProps {
  open: boolean;
  title: string;
  image?: string;
  radioButtons?: OnevocaNewDialogRadioButton[];
  actionButtonTitle: string;
  canCancel: boolean;
  onDone?: () => void;
  onDoneWithRadioButton?: (id: number) => void;
  onClose: () => void;
}

export default function OnevocaNewDialog(props: OnevocaNewDialogProps) {

  const [radioButtons, setRadioButtons] =
    useState<OnevocaNewDialogRadioButton[]>();
  const [radioButtonSelectedId, setRadioButtonSelectedId] = useState<number>(1);

  useEffect(() => {
    setRadioButtons(props.radioButtons);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open]);

  function handleClickContainer() {
    if (props.canCancel) {
      props.onClose();
    }
  }

  function handleClickDialogView(event: React.MouseEvent<HTMLDivElement>) {
    event.stopPropagation();
  }

  function handleClickCheckBoxButton(id: number) {
    if (radioButtons === undefined) return;
    const updated = radioButtons.map((button) => ({
      ...button,
      checked: button.id === id,
    }));
    setRadioButtonSelectedId(id);
    setRadioButtons(updated);
  }

  if (props.open === false) return null;

  return (
    <>
      <div className={styles.container} onClick={handleClickContainer}>
        <div className={styles.dialogContainer} onClick={handleClickDialogView}>
          <div className={styles.contentContainer}>
            <span className={styles.titleText}>{props.title}</span>

            {props.image !== undefined && (
              <img className={styles.image} src={props.image} alt="" />
            )}

            {radioButtons !== undefined && (
              <div className={styles.radioButtonsContainer}>
                {radioButtons.map((button: OnevocaNewDialogRadioButton) => (
                  <ListCheckBoxButton
                    key={button.id}
                    id={button.id}
                    title={button.title}
                    checked={button.checked}
                    onClick={() => {
                      handleClickCheckBoxButton(button.id);
                    }}
                  />
                ))}
              </div>
            )}

            <SpacingView height={"16px"} />

            <BigButton
              title={props.actionButtonTitle}
              variant="normal"
              handleClick={() => {
                if (
                  props.radioButtons !== undefined &&
                  props.onDoneWithRadioButton !== undefined
                ) {
                  props.onDoneWithRadioButton(radioButtonSelectedId);
                  return;
                }

                if (props.onDone !== undefined) {
                  props.onDone();
                }
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
